import { connect } from 'react-redux';
import DownloadNowButton from '../../../components/features/elements/DownloadNowButton';
import { getMonthPlan } from "../../../selectors/plans";
import { getSubscriptionState } from "../../../selectors/subscription";
import { checkout } from "../../../actions/payment";

const mapStateToProps = state => ({
    monthPlan: getMonthPlan(state),
    isPaymentResultPending: state.ui.isPaymentResultPending,
    isPortalPending: state.ui.isCustomerPortalPending,
    subscriptionState: getSubscriptionState(state),
});

export default connect(mapStateToProps, {
    checkout,
})(DownloadNowButton);
